import { Outlet, useLocation } from 'react-router-dom';
import { LanguageSwitcher } from '../i18n/language-switcher';

/**
 * Route prefixes that are shown OUTSIDE the authenticated dashboard layout
 * (which has its own language switch in the sidebar). On these public pages we
 * render a floating language switcher so the language can be changed everywhere —
 * including the login and password flows.
 */
const PUBLIC_PREFIXES = [
  '/login',
  '/sign-up',
  '/forgot-password',
  '/auth',
  '/terms',
  '/privacy',
  '/references',
  '/invitations',
];

const isPublicRoute = (pathname: string) =>
  PUBLIC_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));

export const RootLayout = () => {
  const { pathname } = useLocation();

  return (
    <>
      <Outlet />
      {isPublicRoute(pathname) && (
        <div className="fixed right-4 top-4 z-50">
          <LanguageSwitcher />
        </div>
      )}
    </>
  );
};

export default RootLayout;
